export const types = {
  evaluation: 'Avaliação',
  surgery: 'Cirurgia',
  consultation: 'Consulta',
  exam: 'Exame',
  laboratory: 'Laboratorial',
  procedure: 'Procedimento',
  return: 'Retorno',
  session: 'Sessão',
};

export function getName(value) {
  return types[value] || '-';
}
